/** Report tags that open a block in agent-written markdown, which the markdown editor keeps verbatim as a read-only report block. */
export const REPORT_BLOCK_TAGS = [
  "card-grid",
  "card",
  "hero-card",
  "insight-card",
  "stat",
  "headline",
  "actions",
  "bar-chart",
  "line-chart",
  "heatmap",
  "funnel",
  "funnel-chart",
  // A collapsible section wraps prose, which the editor then shows read-only: it can be deleted as a whole but not edited inside.
  "collapsible-heading",
  "collapsible-text",
  "collapsible",
  "image-grid",
  "ad-performance-table",
  "ad-card-grid",
  "campaign-drilldown",
  "ad-set-drilldown",
  "ad-drilldown",
] as const;
